export default __webpack_public_path__ + "static/media/SNRWB_logo_ekran_kolor_negatyw.001bd9b8.png";